import { Api } from '@axiom/ui';
import type {
  InstantMatch,
  InstantMatches,
  Opportunity,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

export type createInstantMatchesResponseType = {
  numMatchingCandidates: number;
};

class InstantMatchesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  async createInstantMatches(submissionId: Opportunity['submissionId']) {
    return super.write<{ data: createInstantMatchesResponseType }>({
      endpoint: `/instant/matches/create/${submissionId}`,
      method: 'POST',
    });
  }

  readInstantMatches(submissionId: Opportunity['submissionId']) {
    return super.read<{
      data: InstantMatches;
    }>({
      endpoint: `/instant/matches/submissions/${submissionId}`,
      method: 'GET',
    });
  }

  async updateInstantMatchPassed(
    body: Pick<InstantMatch, 'opportunityId' | 'candidateId'>
  ) {
    return super.write<{ data: null }>({
      endpoint: `/instant/matches/pass`,
      body,
      method: 'PUT',
    });
  }

  async updateInstantMatches(submissionId: Opportunity['submissionId']) {
    return super.write<{ data: null }>({
      endpoint: `/instant/matches/refresh/${submissionId}`,
      method: 'POST',
    });
  }

  async refreshInstantMatches(submissionId: Opportunity['submissionId']) {
    return super.invalidate(`/instant/matches/submissions/${submissionId}`);
  }
}

export const InstantMatchesApi = new InstantMatchesApiClass();
